import { useTranslation } from "react-i18next";
import windowStatus from "../../types/generic/WindowStatus";

interface ClientFormWindowStatusProps {
  value: windowStatus;
}

const ClientFormWindowStatusDisplay = ({ value }: ClientFormWindowStatusProps) => {
  const { t } = useTranslation();

  switch (value) {
    case "OPEN":
      return <span>{t("Journey.Window.Open")}</span>;
    case "CLOSED":
      return <span>{t("Journey.Window.Closed")}</span>;
    case "NO-WINDOWS":
      return <span>{t("Journey.Window.NoWindows")}</span>;
    case "UNKNOWN":
    default:
      return <span>{t("Journey.Mode.Unknown")}</span>;
  }
};

export default ClientFormWindowStatusDisplay;
